import { useState, useEffect, useCallback, useRef } from 'react';
import { protectedAPI } from '../services/api';

export const usePagination = (apiUrl, initialPage = 1, initialPageSize = 20, address) => {
  const [data, setData] = useState([]);
  const isFirstRender = useRef(true);
  const [pagination, setPagination] = useState({
    currentPage: initialPage,
    totalPages: 0,
    totalCount: 0,
    pageSize: initialPageSize
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async (page = 1, pageSize = initialPageSize, filters = {}, sortings = {}) => {
    setLoading(true);
    setError(null);
    
    try {
      const queryParams = new URLSearchParams({
        page: page.toString(),
        page_size: pageSize.toString(),
        ...filters,
        ...sortings
      });
      const response = await apiUrl(`${address}&${queryParams}`);

      const result = response.data;
      
      setData(result.results);
      setPagination({
        currentPage: result.current_page || page,
        totalPages: result.total_pages || Math.ceil(result.count / pageSize),
        totalCount: result.count,
        pageSize: result.page_size || pageSize
      });
    } catch (err) {
      setError(err.message);
      console.error('Error fetching data with pagination:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    /*
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    */
    fetchData(initialPage, initialPageSize);
  }, []);

  return {
    data,
    pagination,
    loading,
    error,
    fetchData,
    refetch: () => fetchData(pagination.currentPage, pagination.pageSize)
  };
};